import { usePageMeta } from "@/hooks/use-page-meta";
import { useEffect } from "react";
import { CheckCircle, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();
  usePageMeta({ title: "Demande envoyée - Work&You", description: "Merci ! Votre demande a bien été envoyée. L'équipe Work&You vous recontacte sous 48h.", path: "/thank-you", noindex: true });

  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'Lead');
    }
  }, []);

  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-navy px-6 text-primary-foreground">
      <div className="container relative z-10 text-center">
        <div className="mx-auto max-w-2xl">
          <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-accent">
            <CheckCircle className="h-10 w-10 text-primary" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Demande envoyée avec succès !
          </h1>
          <p className="text-xl md:text-2xl opacity-90 mb-8 leading-relaxed">
            Merci pour votre intérêt. Notre équipe vous recontactera sous 48h.
          </p>
          <Button 
            size="lg"
            className="h-14 px-8 text-base shadow-brand"
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ThankYou;
